<template>
	<joy-page :joyPageStatus="joyPageStatus">
		<div class="setHeightFullGrey">
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
			<template v-if="reportList.length==0">
					<noneData></noneData>
				</template>
			<template v-else>
				<div class="paddingbottom50 marginTopXm">
					<van-panel @click="navReport(item.id)" class="marginBottomXm" v-for="(item,index) in reportList" :key="index" :title="item.title" :desc="item.content" >
					  <div slot="footer">
					   <van-tag  round  type="warning">{{item.created_at}}</van-tag>
					  </div>
					</van-panel>
				</div>
				
			</template>
			<div class="fixBottom">
				<van-button  @click="goAddExperience" type="info" size="large">新增异常</van-button>
			</div>
		</van-pull-refresh>
		
		</div>
		<van-popup
		  v-model="showAdd"
		  position="bottom"
		 round
		  :style="{ height: '90%' }"
		>
			 <van-field
			    v-model="addList.name"
			    clearable
			    label="姓名"
			    placeholder="请输入姓名"
			  />
			  <div class="van-cell van-field">
				  <div class="van-cell__title van-field__label"><span>性别</span></div>
				  <div class="van-cell__value flexRow">
					  <div class="marginRightXm">
					     <van-switch 
					     size="20px"
					     v-model="switchA"
					     />
					  </div>
					   <div  style="margin: 0 15rpx;line-height: 30px;height: 100%;">{{switchA?'男':'女'}}</div>
				  </div>
			  </div>
			   <van-field
			      v-model="addList.title"
			      clearable
			      label="标题"
			      placeholder="请输入标题"
			    />
				<van-field
				   v-model="addList.content"
				   type="textarea"
				   clearable
				   label="异常信息"
				   placeholder="请输入异常信息"
				   rows="3"
				   autosize
				 />
				 <van-cell title="图片上传"></van-cell>
				 <div class="paddingXm">
					 <van-uploader  v-model="imgListMode2"  multiple   />
				 </div>
				 <van-button type="primary"  size="large" @click="AddSave">保存</van-button>
		</van-popup>
		
		<van-popup
		  v-model="showEdit"
		  position="bottom"
		 round
		  :style="{ height: '90%' }"
		>
		<joy-page :joyPageStatus="joyPageStatusEdit">
			 <van-field
			    v-model="list.name"
			    clearable
			    label="姓名"
			    placeholder="请输入姓名"
			  />
			  <div class="van-cell van-field">
				  <div class="van-cell__title van-field__label"><span>性别</span></div>
				  <div class="van-cell__value flexRow">
					  <div class="marginRightXm">
					     <van-switch 
					     size="20px"
					     v-model="switchC"
					     />
					  </div>
					  <div  style="margin: 0 15rpx;line-height: 30px;height: 100%;">{{switchC?'男':'女'}}</div>
				  </div>
			  </div>
			   <van-field
			      v-model="list.title"
			      clearable
			      label="标题"
			      placeholder="请输入标题"
			    />
				<van-field
				   v-model="list.content"
				   type="textarea"
				   clearable
				   label="异常信息"
				   placeholder="请输入异常信息"
				   rows="3"
				   autosize
				 />
				 <van-cell title="图片上传"></van-cell>
				 <div class="paddingXm">
					 <van-uploader  v-model="imgListMode"multiple  :before-read="beforeRead"  />
				 </div>
				 <van-button type="primary"  size="large" @click="editSave">保存</van-button>
		</joy-page>
		</van-popup>
	</joy-page>
</template>

<script>
	import { Toast } from 'vant';
	export default{
		props:['camp_id','user_id','type'],
		data(){
			return{
				showAdd:false,
				joyPageStatusEdit:"",
				showEdit:false,
				joyPageStatus:'',
				isLoading: false,
				reportList:[],
				switchC:null,
				list:[], //修改的list信息
				imgListMode:[],
				addList:[], //新增的list信息
				switchA:false,
				addpic:[],
				imgListMode2:[],
				flag:0,
			}
		},
		watch:{
			showEdit:function(val){
				if(!val){
					this.imgListMode=[];
					this.list=[];
				}
			},
			showAdd:function(val){
				if(!val){
					this.imgListMode=[];
					this.addList=[];
					this.switchA=false;
				}
			},
			imgListMode2:function(val){
				const that=this;
				for (let i in val) {
					that.$lrz(val[i].content,{width:that.$mConfig.width,quality:that.$mConfig.quality}).then(function (rst) {                    			console.log('rst.base64是',rst.base64);
					  that.addpic.push(rst.base64);
					}).catch(function (err) {
						console.log(err);
					});
				};	
			}
		},
		methods:{
			AddSave(){
				const that=this;
				if(that.addList.name=="" || that.addList.name==null){
					that.$dialog.alert({
					  message: '姓名不能为空'
					});
				}else if(that.addList.title=="" || that.addList.title==null){
					that.$dialog.alert({
					  message: '标题不能为空'
					});
				}else if(that.addList.content=="" || that.addList.content==null){
					that.$dialog.alert({
					  message: '异常信息不能为空'
					});
				}else{
					console.log('addpic是',this.addpic,this.addpic.length);
					let sex=that.switchA?0:1;
					let query={
						"name":that.addList.name,
						"sex":sex,
						"title":that.addList.title,
						"content":that.addList.content,
						"pics":that.addpic,
						"camp_id":that.camp_id,
						"partner_id":that.user_id,
					};			
					try{
						that.$axios.post('report/create',query).then(res => {
							if (res.data.code == 200) {
								that.$toast.success('保存成功')
								setTimeout(function() {
									that.reportList.unshift(res.data.data);
									that.showAdd=false;
								}, 500);
							}else{
								that.$toast.fail(res.data.msg)
							}
						})
					}catch(e){
						if (that.$mConfig.debug) {
							console.log(e);
						}
					}
					
					
				}
			},
			// 修改异常里面的图片上传
			beforeRead(file){
				const that=this;
				Toast.loading({
				  duration: 0,       // 持续展示 toast
				  forbidClick: true, // 禁用背景点击
				  loadingType: 'spinner',
				  mask:true,
				  message: '图片上传中',
				});
				if(file.length>1){
						for(let i in file) {
							this.baseImg(file[i],file.length);
						};
				}else{
						let reader = new FileReader();
						reader.readAsDataURL(file);
						reader.onloadend = function () {
							console.log('this.result进来了',this.result)
							that.$lrz(this.result,{width:that.$mConfig.width,quality:that.$mConfig.quality}).then(function (rst) {
								 that.uploadPic(rst.base64,1);
							})
						};
				}
			},
			baseImg(file,fileLength){
				const that=this;
				let reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onloadend = function () {
					that.$lrz(this.result,{width:that.$mConfig.width,quality:that.$mConfig.quality}).then(function (rst) {
						 that.uploadPic(rst.base64,fileLength);
					})
				};
			},
			// 修改异常里面的上传图片到阿里云
			 uploadPic(base64,fileLength){
				const that=this;
				that.$axios.post('report/image',{file:base64,"children_id":this.children_id}).then(res => {
					if(res.data.code==200){
						 that.flag++;
						 console.log('数据是',that.flag,fileLength);
						 if(that.flag=== fileLength){
							that.flag=0;
							Toast.clear();
							setTimeout(function() {
								that.$toast.success('上传成功')
							}, 500);
						 }
						let modeImg=res.data.data.image;
						that.imgListMode.push({url:'http://img.jiarixiaodui.com/'+modeImg});
						}else{
						  that.$toast.fail(res.data.msg)
						  return false;
						}
				})
					
							
			},
			// 保存刚修改的异常
			editSave(){
				const that=this;
				if(that.list.name=="" || that.list.name==null){
					that.$dialog.alert({
					  message: '姓名不能为空'
					});
				}else if(that.list.title=="" || that.list.title==null){
					that.$dialog.alert({
					  message: '标题不能为空'
					});
				}else if(that.list.content=="" || that.list.content==null){
					that.$dialog.alert({
					  message: '异常信息不能为空'
					});
				}else{
					let editImgArray=[]
					for (let i in that.imgListMode) {
						let org=that.imgListMode[i].url.split('http://img.jiarixiaodui.com/');
						editImgArray.push(org[1])
					};
					let sex=that.switchC?0:1;
					let query={
						"name":that.list.name,
						"sex":sex,
						"title":that.list.title,
						"content":that.list.content,
						"pics":editImgArray,
						"camp_id":that.list.camp_id,
						"partner_id":that.list.partner_id,
						"id":that.list.id
						};
											
					try{
						that.$axios.put('report/update',query).then(res => {
							if (res.data.code == 200) {
								that.$toast.success('保存成功')
								setTimeout(function() {
									that.showEdit=false;
									// that.onRefresh();
								}, 500);
							};
						})
					}catch(e){
						if (that.$mConfig.debug) {
							console.log(e);
						}
					}
				}
			},
			// 读取异常申报信息流
			loadReport(){
				this.joyPageStatus = 'loading';
				try{
					this.$axios.get('report/list?camp_id='+this.camp_id+'&partner_id='+this.user_id).then(res => {
						this.joyPageStatus = 'success';
						if (res.data.code == 200) {
							this.reportList=res.data.data;
						};
					}).catch(function (error) {
					  this.joyPageStatus = 'fail';
					});
				}catch(e){
					if (this.$mConfig.debug) {
						console.log(e);
					};
				};
			},
			// 查看异常信息详情/或修改
			navReport(id){
				this.showEdit=true;
				try{
					 this.joyPageStatusEdit = "loading";
					 this.$axios.get('report/info?report_id='+id).then(res => {
					 	this.joyPageStatusEdit = 'success';
					 	for(let i in res.data.data.pics) {
							this.imgListMode.push({url:'http://img.jiarixiaodui.com/'+res.data.data.pics[i],id:res.data.data.id});
					 	 };
					 	this.list=res.data.data;
					 	this.list.sex==0?this.switchC=true:this.switchC=false;
					 })
				}catch(e){
					if (this.$mConfig.debug) {
						console.log(e);
					};
									
				}	
			},
			goAddExperience(){
				this.showAdd=true;
			},
			onRefresh() {
				setTimeout(() => {
					this.isLoading = false;
					this.reload();
					//this.$toast('刷新成功');
				}, 1000);
			},
			reload(){
				this.reportList=[];
				this.loadReport();
			},
		},
		created() {
			this.loadReport();
		},
	}
	
</script>

<style>
</style>
